import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Paper,
  Avatar,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StarIcon from '@mui/icons-material/Star';
import VerifiedIcon from '@mui/icons-material/Verified';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SecurityIcon from '@mui/icons-material/Security';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const IMG = {
  hero1: 'https://images.pexels.com/photos/1191531/pexels-photo-1191531.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  hero2: 'https://images.pexels.com/photos/691046/pexels-photo-691046.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  hero3: 'https://images.pexels.com/photos/248077/pexels-photo-248077.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  necklace: 'https://images.pexels.com/photos/1454171/pexels-photo-1454171.jpeg?auto=compress&cs=tinysrgb&w=600',
  earring: 'https://images.pexels.com/photos/1232931/pexels-photo-1232931.jpeg?auto=compress&cs=tinysrgb&w=600',
  ring: 'https://images.pexels.com/photos/2735970/pexels-photo-2735970.jpeg?auto=compress&cs=tinysrgb&w=600',
  bracelet: 'https://images.pexels.com/photos/3266700/pexels-photo-3266700.jpeg?auto=compress&cs=tinysrgb&w=600',
  pendant: 'https://images.pexels.com/photos/2849742/pexels-photo-2849742.jpeg?auto=compress&cs=tinysrgb&w=600',
  chain: 'https://images.pexels.com/photos/168927/pexels-photo-168927.jpeg?auto=compress&cs=tinysrgb&w=600',
  coins: 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=600',
  pooja: 'https://images.pexels.com/photos/2442893/pexels-photo-2442893.jpeg?auto=compress&cs=tinysrgb&w=600',
  jhumkas: 'https://images.pexels.com/photos/1457801/pexels-photo-1457801.jpeg?auto=compress&cs=tinysrgb&w=600',
  bangle: 'https://images.pexels.com/photos/177332/pexels-photo-177332.jpeg?auto=compress&cs=tinysrgb&w=600',
  studs: 'https://images.pexels.com/photos/371285/pexels-photo-371285.jpeg?auto=compress&cs=tinysrgb&w=600',
  drops: 'https://images.pexels.com/photos/3641056/pexels-photo-3641056.jpeg?auto=compress&cs=tinysrgb&w=600',
  hoops: 'https://images.pexels.com/photos/230290/pexels-photo-230290.jpeg?auto=compress&cs=tinysrgb&w=600',
  gem1: 'https://images.pexels.com/photos/691046/pexels-photo-691046.jpeg?auto=compress&cs=tinysrgb&w=400',
  gem2: 'https://images.pexels.com/photos/248077/pexels-photo-248077.jpeg?auto=compress&cs=tinysrgb&w=400',
  gem3: 'https://images.pexels.com/photos/2442893/pexels-photo-2442893.jpeg?auto=compress&cs=tinysrgb&w=400',
  gem4: 'https://images.pexels.com/photos/2735970/pexels-photo-2735970.jpeg?auto=compress&cs=tinysrgb&w=400',
  men: 'https://images.pexels.com/photos/2735970/pexels-photo-2735970.jpeg?auto=compress&cs=tinysrgb&w=600',
  kids: 'https://images.pexels.com/photos/371285/pexels-photo-371285.jpeg?auto=compress&cs=tinysrgb&w=600',
  bridal: 'https://images.pexels.com/photos/1454171/pexels-photo-1454171.jpeg?auto=compress&cs=tinysrgb&w=600',
  lightweight: 'https://images.pexels.com/photos/3266700/pexels-photo-3266700.jpeg?auto=compress&cs=tinysrgb&w=600',
  fallback: 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=400',
};



const DEFAULT_FEATURED = [
  { id: 1, name: 'Royal Silver Necklace', category: 'Necklaces', price: 12500, weight: '45g', purity: '925 Silver', image: IMG.necklace, is_new_arrival: false },
  { id: 2, name: 'Temple Jhumka Earrings', category: 'Earrings', price: 4800, weight: '18g', purity: '925 Silver', image: IMG.jhumkas, is_new_arrival: true },
  { id: 4, name: 'Classic Silver Bangle', category: 'Bangles', price: 8500, weight: '35g', purity: '925 Silver', image: IMG.bangle, is_new_arrival: false },
  { id: 6, name: 'Peacock Silver Pendant', category: 'Pendants', price: 2800, weight: '12g', purity: '925 Silver', image: IMG.pendant, is_new_arrival: true },
  { id: 9, name: 'Bridal Choker Necklace', category: 'Necklaces', price: 22000, weight: '65g', purity: '925 Silver', image: IMG.chain, is_new_arrival: true },
  { id: 12, name: 'Silver Kada Bangle', category: 'Bangles', price: 6500, weight: '28g', purity: '925 Silver', image: IMG.bracelet, is_new_arrival: false },
];

const Home = () => {
  const navigate = useNavigate();
  const [featuredProducts, setFeaturedProducts] = useState(DEFAULT_FEATURED);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const response = await axios.get('http://localhost:5000/api/products?featured=true');
        if (response.data && response.data.length > 0) {
          setFeaturedProducts(response.data);
        }
      } catch (error) {
        console.error('Using default featured products');
      }
    };
    fetchFeaturedProducts();
  }, []);

  const heroSlides = [
    {
      title: 'Silver Collection',
      subtitle: 'Where tradition meets silver sophistication!',
      gradient: 'linear-gradient(135deg, rgba(27,20,100,0.85) 0%, rgba(13,13,61,0.75) 100%)',
      image: IMG.hero1,
      cta: 'Shop Now',
    },
    {
      title: 'Exquisite Craftsmanship',
      subtitle: 'Handcrafted silver jewelry for every occasion',
      gradient: 'linear-gradient(135deg, rgba(26,26,46,0.8) 0%, rgba(45,27,105,0.7) 100%)',
      image: IMG.hero2,
      cta: 'Explore Collection',
    },
    {
      title: 'Pure Silver Elegance',
      subtitle: 'Tradition wrapped in purity, perfect for every moment',
      gradient: 'linear-gradient(135deg, rgba(15,13,61,0.85) 0%, rgba(27,20,100,0.7) 100%)',
      image: IMG.hero3,
      cta: 'Discover More',
    },
  ];

  const slideCount = heroSlides.length;
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideCount);
    }, 5000);
    return () => clearInterval(timer);
  }, [slideCount]);

  const categoryIcons = [
    { name: 'Fast Ships', icon: '🚚', color: '#E8E0F0' },
    { name: 'Best Sellers', icon: '🏆', color: '#F0E8D0' },
    { name: 'New Arrivals', icon: '✨', color: '#E0E8F5' },
    { name: 'Silver Coins', icon: '🪙', color: '#E8E8E8' },
    { name: 'Pendants', icon: '💫', color: '#F0E0F0' },
    { name: 'Pooja Items', icon: '🪔', color: '#F5ECD7' },
    { name: 'Jhumkas', icon: '💎', color: '#E0F0E8' },
    { name: 'Rings', icon: '💍', color: '#F5E0E0' },
    { name: 'Bangles', icon: '⭕', color: '#E0F0F5' },
    { name: 'Earrings', icon: '✧', color: '#F0E5D5' },
    { name: 'Necklaces', icon: '📿', color: '#E5E0F5' },
    { name: 'Silver Chains', icon: '🔗', color: '#E8E8E8' },
  ];

  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          height: { xs: '400px', md: '600px' },
          overflow: 'hidden',
        }}
      >
        {heroSlides.map((slide, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            animate={{
              opacity: currentSlide === index ? 1 : 0,
              scale: currentSlide === index ? 1 : 1.1,
            }}
            transition={{ duration: 1 }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
                backgroundImage: `${slide.gradient}, url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Container>
                <motion.div
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.3, duration: 0.8 }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      color: 'white',
                      textAlign: 'center',
                      fontWeight: 700,
                      mb: 2,
                      fontSize: { xs: '2rem', md: '3.5rem' },
                    }}
                  >
                    {slide.title}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      color: 'white',
                      textAlign: 'center',
                      mb: 4,
                      fontSize: { xs: '1rem', md: '1.5rem' },
                    }}
                  >
                    {slide.subtitle}
                  </Typography>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={() => navigate('/store')}
                      sx={{
                        backgroundColor: '#D4AF37',
                        color: '#1A1A2E',
                        px: 4,
                        py: 1.5,
                        fontSize: '1.1rem',
                        fontWeight: 600,
                        '&:hover': {
                          backgroundColor: '#E8D48B',
                          transform: 'scale(1.05)',
                        },
                        transition: 'all 0.3s',
                      }}
                      endIcon={<ArrowForwardIcon />}
                    >
                      {slide.cta}
                    </Button>
                  </Box>
                </motion.div>
              </Container>
            </Box>
          </motion.div>
        ))}

        <Box
          sx={{
            position: 'absolute',
            bottom: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: 1,
          }}
        >
          {heroSlides.map((_, index) => (
            <Box
              key={index}
              onClick={() => setCurrentSlide(index)}
              sx={{
                width: currentSlide === index ? 30 : 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: currentSlide === index ? 'white' : 'rgba(255,255,255,0.5)',
                cursor: 'pointer',
                transition: 'all 0.3s',
              }}
            />
          ))}
        </Box>
      </Box>

      <Container sx={{ py: { xs: 3, md: 6 } }}>
        <Box sx={{ mb: 6, overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              overflowX: 'auto',
              pb: 2,
              '&::-webkit-scrollbar': {
                height: 8,
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f1f1f1',
                borderRadius: 10,
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#C0C0C0',
                borderRadius: 10,
              },
            }}
          >
            {categoryIcons.map((cat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ scale: 1.1 }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: { xs: 75, md: 100 },
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate('/store')}
                >
                  <Avatar
                    sx={{
                      width: { xs: 56, md: 70 },
                      height: { xs: 56, md: 70 },
                      backgroundColor: cat.color,
                      fontSize: { xs: '1.5rem', md: '2rem' },
                      mb: 1,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    }}
                  >
                    {cat.icon}
                  </Avatar>
                  <Typography
                    variant="caption"
                    sx={{
                      textAlign: 'center',
                      fontWeight: 500,
                      fontSize: '0.75rem',
                    }}
                  >
                    {cat.name}
                  </Typography>
                </Box>
              </motion.div>
            ))}
          </Box>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Silver Collection
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Where tradition meets silver sophistication!
          </Typography>

          <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 4, md: 8 } }}>
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <Paper
                  sx={{
                    position: 'relative',
                    height: { xs: 250, md: 350 },
                    borderRadius: 3,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    background: 'linear-gradient(135deg, #1B1464 0%, #2D1B69 100%)',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      transition: 'transform 0.3s',
                    },
                  }}
                  onClick={() => navigate('/store/coins-bars')}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${IMG.coins})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      opacity: 0.3,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'relative',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: 'white',
                      p: 4,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 700,
                        mb: 2,
                        textAlign: 'center',
                        color: '#D4AF37',
                      }}
                    >
                      Silver Coins
                      <br />
                      & Bars
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 3,
                        textAlign: 'center',
                        maxWidth: 300,
                      }}
                    >
                      Tradition wrapped in purity, perfect for every Shagun moment!
                    </Typography>
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: 'white',
                        color: 'white',
                        px: 4,
                        '&:hover': {
                          borderColor: '#D4AF37',
                          backgroundColor: 'rgba(255,255,255,0.1)',
                        },
                      }}
                    >
                      SHOP NOW
                    </Button>
                  </Box>
                </Paper>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <Paper
                  sx={{
                    position: 'relative',
                    height: { xs: 250, md: 350 },
                    borderRadius: 3,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    background: 'linear-gradient(135deg, #0F0D3D 0%, #1B1464 100%)',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      transition: 'transform 0.3s',
                    },
                  }}
                  onClick={() => navigate('/store/silver-articles')}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${IMG.pooja})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      opacity: 0.3,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'relative',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: 'white',
                      p: 4,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 700,
                        mb: 2,
                        textAlign: 'center',
                        color: '#D4AF37',
                      }}
                    >
                      Silver
                      <br />
                      Articles
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 3,
                        textAlign: 'center',
                        maxWidth: 300,
                      }}
                    >
                      Embrace auspiciousness this Diwali with divine silver articles.
                    </Typography>
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: 'white',
                        color: 'white',
                        px: 4,
                        '&:hover': {
                          borderColor: '#D4AF37',
                          backgroundColor: 'rgba(255,255,255,0.1)',
                        },
                      }}
                    >
                      SHOP NOW
                    </Button>
                  </Box>
                </Paper>
              </motion.div>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Earring Collection
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Our Exclusive Earring Collection
          </Typography>

          <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 4, md: 8 } }}>
            {[
              { name: 'Studs Collection', bg: '#F5F0FF', image: IMG.studs },
              { name: 'Jhumkas Collection', bg: '#FFF8F0', image: IMG.jhumkas },
              { name: 'Drops Collection', bg: '#F0F5FF', image: IMG.drops },
              { name: 'Hoops-Balis Collection', bg: '#FFF5F0', image: IMG.hoops },
            ].map((item, index) => (
              <Grid item xs={6} sm={6} md={3} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -5 }}
                >
                  <Paper
                    sx={{
                      position: 'relative',
                      height: { xs: 150, md: 200 },
                      borderRadius: 2,
                      overflow: 'hidden',
                      cursor: 'pointer',
                      backgroundColor: item.bg,
                      border: '2px solid #E8E0F0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      p: 3,
                      '&:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                      },
                    }}
                    onClick={() => navigate('/store/earrings')}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#1B1464',
                        fontStyle: 'italic',
                        maxWidth: '55%',
                        fontSize: { xs: '0.85rem', sm: '1rem', md: '1.15rem' },
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Box
                      component="img"
                      src={item.image}
                      sx={{
                        height: '100%',
                        width: 'auto',
                        objectFit: 'contain',
                      }}
                    />
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Gemstone Jewellery
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Capturing timeless grace in each precious stone
          </Typography>

          <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 4, md: 8 } }}>
            {[
              { image: IMG.gem1, span: 1 },
              { image: IMG.gem2, span: 1 },
              { image: IMG.gem3, span: 1 },
              { image: IMG.gem4, span: 1 },
            ].map((item, index) => (
              <Grid item xs={6} sm={6} md={3} key={index}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.05 }}
                >
                  <Paper
                    sx={{
                      position: 'relative',
                      paddingTop: '100%',
                      borderRadius: 2,
                      overflow: 'hidden',
                      cursor: 'pointer',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    }}
                    onClick={() => navigate('/store')}
                  >
                    <Box
                      component="img"
                      src={item.image}
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Handpicked Just For You!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Our lightweight collection keeps you stylish and comfortable from dawn to dusk.
          </Typography>

          <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 4, md: 6 } }}>
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <Paper
                  sx={{
                    position: 'relative',
                    height: { xs: 250, md: 400 },
                    borderRadius: 3,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    background: 'linear-gradient(135deg, #1B1464 0%, #0F0D3D 100%)',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      transition: 'transform 0.3s',
                    },
                  }}
                  onClick={() => navigate('/store/necklaces')}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${IMG.necklace})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      opacity: 0.4,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'relative',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: 'white',
                      p: 4,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontStyle: 'italic',
                        mb: 1,
                        opacity: 0.9,
                      }}
                    >
                      Statement
                    </Typography>
                    <Typography
                      variant="h2"
                      sx={{
                        fontWeight: 700,
                        mb: 2,
                        textAlign: 'center',
                        fontSize: { xs: '1.8rem', md: '3rem' },
                      }}
                    >
                      NECKLACE SETS
                    </Typography>
                  </Box>
                </Paper>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    <Paper
                      sx={{
                        position: 'relative',
                        height: { xs: 150, md: 190 },
                        borderRadius: 3,
                        overflow: 'hidden',
                        cursor: 'pointer',
                        background: 'linear-gradient(135deg, #2D1B69 0%, #4A2D8A 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 3,
                        '&:hover': {
                          transform: 'scale(1.02)',
                          transition: 'transform 0.3s',
                        },
                      }}
                      onClick={() => navigate('/store')}
                    >
                      <Box sx={{ color: 'white', maxWidth: '50%' }}>
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: 700,
                            mb: 1,
                            fontSize: { xs: '1.3rem', md: '2rem' },
                          }}
                        >
                          LIGHTWEIGHT
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            fontStyle: 'italic',
                            opacity: 0.9,
                          }}
                        >
                          Jewellery
                        </Typography>
                      </Box>
                      <Box
                        component="img"
                        src={IMG.lightweight}
                        sx={{
                          height: '100%',
                          width: 'auto',
                          objectFit: 'cover',
                        }}
                      />
                    </Paper>
                  </motion.div>
                </Grid>

                <Grid item xs={12}>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    viewport={{ once: true }}
                  >
                    <Paper
                      sx={{
                        position: 'relative',
                        height: { xs: 150, md: 190 },
                        borderRadius: 3,
                        overflow: 'hidden',
                        cursor: 'pointer',
                        backgroundImage: `url(${IMG.earring})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        p: 3,
                        '&:hover': {
                          transform: 'scale(1.02)',
                          transition: 'transform 0.3s',
                        },
                      }}
                      onClick={() => navigate('/store/earrings')}
                    >
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: 'linear-gradient(90deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 100%)',
                        }}
                      />
                      <Box sx={{ position: 'relative', color: 'white' }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontStyle: 'italic',
                            mb: 0.5,
                          }}
                        >
                          Stylish
                        </Typography>
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: 700,
                          }}
                        >
                          EARRINGS
                        </Typography>
                      </Box>
                    </Paper>
                  </motion.div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Silver Jewellery
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Fine jewellery for life's meaningful moments
          </Typography>

          <Grid container spacing={{ xs: 1.5, md: 2 }} sx={{ mb: { xs: 4, md: 8 } }}>
            {[
              { name: 'Elegant Chains', image: IMG.chain },
              { name: 'Stunning Ring', image: IMG.ring },
              { name: 'Modern Mangalsutras', image: IMG.necklace },
              { name: 'Trendy Pendants', image: IMG.pendant },
              { name: 'Gorgeous Bangles', image: IMG.bangle },
              { name: 'Stylish Earrings', image: IMG.earring },
            ].map((item, index) => (
              <Grid item xs={6} sm={6} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.03 }}
                >
                  <Paper
                    sx={{
                      position: 'relative',
                      height: { xs: 110, sm: 130, md: 150 },
                      borderRadius: { xs: 3, md: 20 },
                      overflow: 'hidden',
                      cursor: 'pointer',
                      background: 'linear-gradient(135deg, #E8E0F0 0%, #D5D0E0 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      px: 3,
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    }}
                    onClick={() => navigate('/store')}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#0F0D3D',
                        maxWidth: '55%',
                        fontSize: { xs: '0.8rem', sm: '0.95rem', md: '1.1rem' },
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Box
                      component="img"
                      src={item.image}
                      sx={{
                        height: '90%',
                        width: 'auto',
                        objectFit: 'contain',
                      }}
                    />
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Our Collection
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Discover our latest jewellery collection!
          </Typography>

          <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 4, md: 8 } }}>
            {[
              { name: 'LEGENDZ', subtitle: "Men's Collection", bg: 'linear-gradient(135deg, #1B1464 0%, #2D1B69 100%)', image: IMG.men },
              { name: 'STARLET', subtitle: "Kids Collection", bg: 'linear-gradient(135deg, #2C5282 0%, #4A90A4 100%)', image: IMG.kids },
              { name: 'Bridal Silver', subtitle: 'Collection', bg: 'linear-gradient(135deg, #4A1942 0%, #6B2D5B 100%)', image: IMG.bridal },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.15 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -10 }}
                >
                  <Paper
                    sx={{
                      position: 'relative',
                      height: { xs: 280, md: 400 },
                      borderRadius: 3,
                      overflow: 'hidden',
                      cursor: 'pointer',
                      background: item.bg,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      p: 4,
                      boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
                    }}
                    onClick={() => navigate('/store')}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(${item.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.2,
                      }}
                    />
                    <Box sx={{ position: 'relative', color: 'white', textAlign: 'center' }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontWeight: 700,
                          mb: 1,
                          letterSpacing: 2,
                          fontSize: { xs: '1.8rem', md: '2.5rem' },
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          mb: 3,
                          opacity: 0.9,
                        }}
                      >
                        {item.subtitle}
                      </Typography>
                      <Button
                        variant="outlined"
                        sx={{
                          borderColor: 'white',
                          color: 'white',
                          px: 4,
                          '&:hover': {
                            borderColor: 'white',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                          },
                        }}
                      >
                        DISCOVER
                      </Button>
                    </Box>
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Featured Products
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Explore our handpicked selection of premium silver jewelry
          </Typography>

          <Grid container spacing={{ xs: 2, md: 3 }}>
            {featuredProducts.slice(0, 6).map((product, index) => (
              <Grid item xs={6} sm={6} md={4} key={product.id}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ y: -10 }}
                >
                  <Card
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                      borderRadius: 2,
                      overflow: 'hidden',
                      cursor: 'pointer',
                      transition: 'all 0.3s',
                      '&:hover': {
                        boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
                      },
                    }}
                    onClick={() => navigate(`/product/${product.id}`)}
                  >
                    <Box sx={{ position: 'relative', paddingTop: '100%', overflow: 'hidden' }}>
                      <CardMedia
                        component="img"
                        image={product.image || IMG.fallback}
                        alt={product.name}
                        onError={(e) => { e.target.onerror = null; e.target.src = IMG.fallback; }}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.3s',
                          '&:hover': {
                            transform: 'scale(1.1)',
                          },
                        }}
                      />
                      {product.is_new_arrival && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            backgroundColor: '#1B1464',
                            color: 'white',
                            px: 2,
                            py: 0.5,
                            borderRadius: 1,
                            fontSize: '0.75rem',
                            fontWeight: 600,
                          }}
                        >
                          NEW
                        </Box>
                      )}
                    </Box>
                    <CardContent sx={{ flexGrow: 1, p: { xs: 1.5, md: 2 } }}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#1B1464',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: 1,
                          fontSize: { xs: '0.6rem', md: '0.75rem' },
                        }}
                      >
                        {product.category}
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          mb: 1,
                          fontSize: { xs: '0.8rem', md: '1rem' },
                        }}
                      >
                        {product.name}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                        {[...Array(5)].map((_, i) => (
                          <StarIcon key={i} sx={{ fontSize: 16, color: '#FFD700' }} />
                        ))}
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#1B1464',
                          fontWeight: 700,
                          fontSize: { xs: '0.9rem', md: '1.15rem' },
                        }}
                      >
                        ₹{product.price.toLocaleString()}
                      </Typography>
                      {product.weight && (
                        <Typography variant="caption" sx={{ color: '#666', display: { xs: 'none', sm: 'block' } }}>
                          Weight: {product.weight} | Purity: {product.purity}
                        </Typography>
                      )}
                    </CardContent>
                    <CardActions sx={{ p: { xs: 1, md: 2 }, pt: 0 }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        size="small"
                        sx={{
                          borderColor: '#1B1464',
                          color: '#1B1464',
                          fontSize: { xs: '0.7rem', md: '0.85rem' },
                          py: { xs: 0.5, md: 1 },
                          '&:hover': {
                            borderColor: '#0F0D3D',
                            backgroundColor: '#1B1464',
                            color: 'white',
                          },
                        }}
                      >
                        View Details
                      </Button>
                    </CardActions>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* ── Malabar-Style Trust Badges / Our Promises ── */}
        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            sx={{ textAlign: 'center', mb: 1, fontWeight: 700, color: '#1A1A2E', fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' } }}
          >
            Our Promises
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: 'center', mb: 5, color: '#555555' }}
          >
            The promises that we'll never break
          </Typography>

          <Box
            sx={{
              display: 'flex',
              gap: 3,
              overflowX: 'auto',
              pb: 2,
              px: 1,
              '&::-webkit-scrollbar': { height: 6 },
              '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1', borderRadius: 10 },
              '&::-webkit-scrollbar-thumb': { backgroundColor: '#D4AF37', borderRadius: 10 },
            }}
          >
            {[
              { icon: <VerifiedIcon sx={{ fontSize: 36, color: '#D4AF37' }} />, title: 'BIS Hallmarked', desc: '100% certified purity on every silver piece' },
              { icon: <LocalShippingIcon sx={{ fontSize: 36, color: '#D4AF37' }} />, title: 'Free Shipping', desc: 'Complimentary delivery on orders above ₹5,000' },
              { icon: <SecurityIcon sx={{ fontSize: 36, color: '#D4AF37' }} />, title: 'Secure Payments', desc: '100% secure and encrypted transactions' },
              { icon: <AutorenewIcon sx={{ fontSize: 36, color: '#D4AF37' }} />, title: 'Easy Exchange', desc: 'Hassle-free exchange at any of our 3 stores' },
              { icon: <CardGiftcardIcon sx={{ fontSize: 36, color: '#D4AF37' }} />, title: 'Gift Wrapping', desc: 'Complimentary luxury gift packaging' },
              { icon: <WorkspacePremiumIcon sx={{ fontSize: 36, color: '#D4AF37' }} />, title: 'Lifetime Maintenance', desc: 'Free polishing & maintenance for life' },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.08 }}
                viewport={{ once: true }}
                style={{ minWidth: 180 }}
              >
                <Paper
                  sx={{
                    p: { xs: 2, md: 3 },
                    textAlign: 'center',
                    minWidth: { xs: 180, md: 220 },
                    height: '100%',
                    borderRadius: 3,
                    border: '1px solid #F0EDE8',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                    transition: 'all 0.3s',
                    '&:hover': {
                      boxShadow: '0 8px 24px rgba(27,20,100,0.12)',
                      borderColor: '#D4AF37',
                      transform: 'translateY(-4px)',
                    },
                  }}
                >
                  <Box sx={{ mb: 1.5 }}>{item.icon}</Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1A1A2E', mb: 0.5 }}>
                    {item.title}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#777', lineHeight: 1.4, display: 'block' }}>
                    {item.desc}
                  </Typography>
                </Paper>
              </motion.div>
            ))}
          </Box>
        </Box>

        {/* ── One Day Shipping Banner ── */}
        <Box
          sx={{
            mb: 8,
            background: 'linear-gradient(135deg, #FDF8E8 0%, #FFF8E1 100%)',
            borderRadius: 3,
            p: { xs: 3, md: 5 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 3,
            border: '1px solid #E8D48B',
          }}
        >
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1B1464', mb: 1, fontSize: { xs: '1.3rem', md: '2rem' } }}>
              🚚 One Day Shipping
            </Typography>
            <Typography variant="body1" sx={{ color: '#555', maxWidth: 500, fontSize: { xs: '0.85rem', md: '1rem' } }}>
              Experience convenience with our one-day shipping, ensuring your silver jewelry arrives at your doorstep quickly and safely.
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/store')}
            sx={{
              backgroundColor: '#D4AF37',
              color: '#1A1A2E',
              px: 4,
              py: 1.5,
              fontWeight: 600,
              '&:hover': { backgroundColor: '#B8960C' },
            }}
            endIcon={<ArrowForwardIcon />}
          >
            Shop Now
          </Button>
        </Box>

        {/* ── CTA Banner ── */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1B1464 0%, #2D1B69 100%)',
            borderRadius: 3,
            p: { xs: 3, md: 6 },
            textAlign: 'center',
            color: 'white',
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' } }}>
              Discover Our Silver Collection
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9, fontSize: { xs: '0.9rem', md: '1.15rem' } }}>
              Explore exquisite silver jewelry crafted with love and tradition
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/store')}
              sx={{
                backgroundColor: '#D4AF37',
                color: '#1A1A2E',
                px: 5,
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#E8D48B',
                  transform: 'scale(1.05)',
                },
                transition: 'all 0.3s',
              }}
            >
              Explore All Products
            </Button>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;
